import { Container, Stack, Typography } from '@mui/material';
import * as React from 'react';
import { Outlet } from 'react-router-dom';
import { HEADER_HEIGHT } from '../../data/constants';

interface Props {
	title: JSX.Element;
}

const FullPageLayout = (props: Props) => {
	const { title } = props;
	return (
		<Container
			maxWidth='lg'
			sx={{
				pt: 4,
				pb: 4,
				height: `calc(100vh - ${HEADER_HEIGHT}px)`,
			}}
		>
			<Stack spacing={2} sx={{ height: '100%' }}>
				<Typography variant='h3'>{title}</Typography>
				<Outlet />
			</Stack>
		</Container>
	);
};

export default FullPageLayout;
